import { EDealType } from '../repositories/cpd/entities/v1_create_cpd_draft/PublicV1CreateCpdDraftRequest';
import { IRegion } from '../repositories/cpd/entities/region/Region';

export interface IDealTypeOption {
  label: string;
  value: EDealType;
}

export interface IRegionOption {
  label: string;
  value: number;
}

export const DEAL_TYPE_OPTIONS: IDealTypeOption[] = [
  {
    label: 'Продать',
    value: EDealType.Sale,
  },
  {
    label: 'Купить',
    value: EDealType.Buy,
  },
  {
    label: 'Продать и купить',
    value: EDealType.Unknown,
  },
];

export const mapRegionsListToOptions = (regions: IRegion[]): IRegionOption[] => {
  return regions.map(region => ({
    label: region.name,
    value: region.id,
  }));
};

export const MARKETING_AGREEMENT = 'https://www.cian.ru/legal-documents/soglasie_na_poluchenie_reklamnyx_rassylok_258';
export const CONSENT_PERSONAL_DATA =
  'https://cdn.cian.site/frontend/info-assets/cpd/soglasheniye_po_obrabotke_addform_2_2025.pdf';
export const PRIVACY_POLICY = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_627';
